{
  "CONTACTS_FILTER": {
    "TITLE": "ตัวกรองรายชื่อผู้ติดต่อ",
    "SUBTITLE": "เพิ่มตัวกรองด้านล่างและคลิก 'ส่ง' เพื่อกรองรายชื่อผู้ติดต่อ",
    "EDIT_CUSTOM_SEGMENT": "Edit Segment",
    "CUSTOM_VIEWS_SUBTITLE": "Add or remove filters and update your segment.",
    "ADD_NEW_FILTER": "เพิ่มตัวกรอง",
    "CLEAR_ALL_FILTERS": "ล้างตัวกรองทั้งหมด",
    "FILTER_DELETE_ERROR": "ควรเลือกอย่างน้อย 1 ตัวกรองเพื่อบันทึก",
    "SUBMIT_BUTTON_LABEL": "ส่ง",
    "UPDATE_BUTTON_LABEL": "Update Segment",
    "CANCEL_BUTTON_LABEL": "ยกเลิก",
    "CLEAR_BUTTON_LABEL": "ล้างตัวกรอง",
    "EMPTY_VALUE_ERROR": "โปรดระบุค่า",
    "SEGMENT_LABEL": "Segment Name",
    "SEGMENT_QUERY_LABEL": "Segment Query",
    "TOOLTIP_LABEL": "ตัวกรองรายชื่อผู้ติดต่อ",
    "QUERY_DROPDOWN_LABELS": {
      "AND": "และ",
      "OR": "หรือ"
    },
    "OPERATOR_LABELS": {
      "equal_to": "เท่ากับ",
      "not_equal_to": "ไม่เท่ากับ",
      "contains": "มี",
      "does_not_contain": "ไม่มี",
      "is_present": "ที่แสดง",
      "is_not_present": "ที่ไม่แสดง",
      "is_greater_than": "หลังจาก",
      "is_lesser_than": "ก่อนหน้า",
      "days_before": "x วันก่อน"
    },
    "ERRORS": {
      "VALUE_REQUIRED": "โปรดระบุค่า"
    },
    "ATTRIBUTES": {
      "NAME": "ชื่อ",
      "EMAIL": "อีเมล์",
      "PHONE_NUMBER": "หมายเลขโทรศัพท์",
      "IDENTIFIER": "ตัวระบุ",
      "CITY": "เมือง",
      "COUNTRY": "ประเทศ",
      "CUSTOM_ATTRIBUTE_LIST": "รายการ",
      "CUSTOM_ATTRIBUTE_TEXT": "ข้อความ",
      "CUSTOM_ATTRIBUTE_NUMBER": "ตัวเลข",
      "CUSTOM_ATTRIBUTE_LINK": "ลิงก์",
      "CUSTOM_ATTRIBUTE_CHECKBOX": "ช่องทำเครื่องหมาย",
      "CREATED_AT": "สร้างเมื่อ",
      "LAST_ACTIVITY": "ล่าสุดเมื่อ",
      "REFERER_LINK": "Referrer link",
      "BLOCKED": "Blocked",
      "LABELS": "ป้ายกำกับ"
    },
    "GROUPS": {
      "STANDARD_FILTERS": "ตัวกรองมาตรฐาน",
      "ADDITIONAL_FILTERS": "ตัวกรองเพิ่มเติม",
      "CUSTOM_ATTRIBUTES": "แอตทริบิวต์ที่กำหนดเอง"
    }
  }
}
